import { InjectionToken } from '@angular/core';

export const MEMBERS_API_URL = new InjectionToken<string>('MEMBERS_API_URL');